const BASE_POPUP_Z_INDEX = 99000
const POPUP_Z_INDEX_STEP = 10

const openPopups: symbol[] = []

export interface PopupStackRegistration {
  id: symbol
  layer: number
  overlayZIndex: number
  popupZIndex: number
  release: () => void
}

function resolvePopupZIndex(layer: number): Pick<
  PopupStackRegistration,
  'overlayZIndex' | 'popupZIndex'
> {
  const baseZIndex = BASE_POPUP_Z_INDEX + layer * POPUP_Z_INDEX_STEP

  return {
    overlayZIndex: baseZIndex,
    popupZIndex: baseZIndex + 1,
  }
}

export function registerPopupStackLayer(): PopupStackRegistration {
  const id = Symbol('base-popup')
  openPopups.push(id)
  const layer = openPopups.length - 1
  const zIndex = resolvePopupZIndex(layer)

  return {
    id,
    layer,
    ...zIndex,
    release: () => {
      const index = openPopups.indexOf(id)
      if (index !== -1) {
        openPopups.splice(index, 1)
      }
    },
  }
}

export function isTopPopupStackLayer(id: symbol | null): boolean {
  if (!id) {
    return false
  }

  return openPopups[openPopups.length - 1] === id
}
